import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import {Routes, Route, NavLink, Outlet,Navigate, useLocation, useNavigate} from 'react-router-dom';
import routes from './Modules/RoutesConfig';
import NavLinks from "./components/navigation/NavLinks";
import {ReactElement} from "react";
import {RoutesList} from "./Modules/RoutesList";
import {SignUp} from "./components/SignUp";
import {Login} from "./components/Login";
import {NotFound} from "./components/NotFound";
import {UserDetails} from "./components/navigation/UserDetails";
import {Logout} from "./components/navigation/Logout";
import {useSelector} from "react-redux";
import {RootState} from "./app/store";
import {MobileSideBar} from "./components/navigation/MobileSideBar";
import {BrowserSideBar} from "./components/navigation/BorwserSideBar";

const drawerWidth = 240;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const RegisterRoutes = () =>{

    const location = useLocation()



    const  RequireAuth = ()  => {
        const _token = useSelector(((state:RootState) => state.auth.token))
        let isAuthenticated = _token ? true : false;
        if (!isAuthenticated) {
            // Redirect them to the /login page, but save the current location they were
            // trying to go to when they were redirected. This allows us to send them
            // along to that page after they login, which is a nicer user experience
            // than dropping them off on the home page.
            return <Navigate to={RoutesList.Login.path} state={{ from: location }} replace={true} />;
        }

        return <Outlet />;
    }

    interface AlloRoutes{
        roles : string[]
        Component : ReactElement,
    }

    const AllowRoute = ({roles,Component} : AlloRoutes) =>{
        const role = useSelector(((state:RootState) => state.auth.role))
        if(!roles.includes(role)){
            return <Navigate to={RoutesList.Login.path}  replace={true} />;
        }
        return Component;
    }

    return(
        <Routes>
            <Route path={RoutesList.SignUp.path} element={<SignUp />} />
            <Route path={RoutesList.Login.path} element={<Login />} />

            <Route element={<RequireAuth />}>
                {
                    routes.map((r,i )=>(
                        <Route
                            key = {i}
                            path={r.path}
                            element={<AllowRoute roles={r.roles} Component={r.component} />}
                        />
                    ))
                }
            </Route>
            <Route path="*" element={<NotFound />}/>
        </Routes>
    )
}

export default function App(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
      <div>
          <UserDetails/>
          <Divider variant="middle" />
          <NavLinks />
          <Logout/>
      </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  const location = useLocation()

  return (
      <Box sx={{ display: 'flex'}}>
          {
              ( location.pathname ===RoutesList.Login.path || location.pathname ===RoutesList.SignUp.path || location.key === "default")? "" : <>
                  <CssBaseline />
                  {/*mobile side bar */}
                  <MobileSideBar drawerWidth={drawerWidth} handleDrawerToggle={handleDrawerToggle} />

                  {/*browser side bar*/}
                  <BrowserSideBar
                      drawerWidth={drawerWidth}
                      handleDrawerToggle={handleDrawerToggle}
                      drawer={drawer}
                      mobileOpen={mobileOpen}
                      container={container}
                      />
              </>

          }

          {/*main content*/}
          <Box
              component="main"
              sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` },
                  marginTop:{
                      xs:"50px",
                      lg:"0px",
                      md:"0px",
              }
              }}
          >
              {RegisterRoutes()}
          </Box>

      </Box>
  );
}
